import { jsx as _jsx } from "react/jsx-runtime";
import { Tag } from "antd";
import { getWorkShiftStatusColor, getWorkShiftStatusLabel, } from "@/types/workShift/workShift.common";
export const WorkShiftStatusTag = ({ status }) => {
    return (_jsx(Tag, { color: getWorkShiftStatusColor(status), children: getWorkShiftStatusLabel(status) }));
};
